import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import LabelledTextBox from '../../components/LabelledTextBox';
import { addValveDeficiency } from '../../services/api';
import useAuth from '../../services/authentication/useAuth';
import EventEmitter from '../../services/events';
import { makeValveDeficiency } from '../../models';
import LabelledEditablePicker from '../../components/LabelledEditablePicker';

const DEFAULT_DEFICIENCY_TYPES = [
  'Stuck Valve',
  'Hard to Turn',
  'Leaking Bonnet',
  'Leaking Packing',
  'Broken Box',
  'Cannot Locate'
];

const AddValveDeficiencyModal = ({ open, toggle, onComplete, onCancel, valveId }) => {
  const { companyId } = useAuth();
  const [valveDeficiency, setValveDeficiency] = useState(makeValveDeficiency({ companyId, valveId }));

  const save = async () => {
    try {
      valveDeficiency.validate();
      const result = await addValveDeficiency(valveDeficiency);
      onComplete(result.id);
      resetState();
    } catch (error) {
      console.log(error);
      if (error.name === 'ValidationError') {
        EventEmitter.emit('show-error', { title: 'Error Saving Valve Deficiency', body: error.message.split('\n').map((str, idx) => <p key={idx}>{str}</p>) });
      } else {
        EventEmitter.emit('show-error', { title: 'Error Saving Valve Deficiency', body: 'Unable to save valve deficiency.' });
      }
    }
  };

  const cancel = async () => {
    onCancel();
    resetState();
  };

  const resetState = () => {
    setValveDeficiency(makeValveDeficiency({ companyId, valveId }));
  };

  const onChange = e => {
    setValveDeficiency(makeValveDeficiency({ ...valveDeficiency, [e.target.name]: e.target.value }));
  };

  const onBlur = e => {
    const type = e.target.type;
    let value = e.target.value;
    switch (type) {
      case 'number':
        value = +value;
        break;
    }

    setValveDeficiency(makeValveDeficiency({ ...valveDeficiency, [e.target.name]: value }));
  };

  return (
    <Modal isOpen={open} toggle={toggle}>
      <ModalHeader>
        <div>Add Valve Deficiency</div>
      </ModalHeader>
      <ModalBody>
          <div className='details'>
            <LabelledEditablePicker label="Deficiency Type" value={valveDeficiency.deficiencyType} name="deficiencyType" onChange={onChange} onBlur={onBlur}>
              {DEFAULT_DEFICIENCY_TYPES.map((type, idx) => (
                <option key={idx} value={type}></option>
              ))}
            </LabelledEditablePicker>
            <LabelledTextBox label="Note" value={valveDeficiency.note} name="note" onChange={onChange} onBlur={onBlur} />
          </div>
      </ModalBody>
      <ModalFooter>
        <div className="actions">
          <button type="button" className="btn btn-secondary" onClick={cancel}>Cancel</button>
          <button type="button" className="btn btn-primary" onClick={save}>Save</button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default AddValveDeficiencyModal;